import {
  ValidateJSModel,
  BranchCollectionModel,
  BranchCollectionItemModel,
} from 'forms/shared/types';

const branchCollectionModelValidator: ValidateJSModel<BranchCollectionModel<
  BranchCollectionItemModel
>> = {
  branch: {},
  // This is disabled, as BranchCollection's branch might not be used at all.
  // branch: {
  //   model: { validator: branchModelValidator },
  // },
  items: {
    length: {
      minimum: 1,
    },
  },
};

export default branchCollectionModelValidator;
